module.exports = "<p>\r\n  {{errorMessage}}\r\n</p>"